<template>
  <main>
    <go-back :text="getGoBackText" class="mt-3" @click="handleBack" v-if="currentProfile && currentProfile.id" :class="{ 'pl-2': $mq === 'xs' || $mq ==='sm', 'pl-5': $mq !== 'xs' || $mq !=='sm'}"/>
    <div class="k-onboarding__steps" :style="{ margin: currentProfile && currentProfile.id ? '10px auto 35px' : '55px auto 35px' }">
      <div
        class="k-onboarding__step-line-wrapper"
        :data-test="`index_${currentIndex}`"
        v-bind:key="currentIndex"
        v-for="currentIndex in maxTabs"
        :style="{ 'pointer-events': !routeIndexConditions[currentIndex - 1] ? 'none' : 'all' }"
      >
        <router-link
          :class="[
              'k-onboarding__step-dot',
              `route-index-current-${currentIndex}`,
              {'step-active': currentIndex === $route.meta.tabIndex},
              {'step-finished': currentIndex < $route.meta.tabIndex},
          ]"
          :to="{name: links[currentIndex - 1].name}"
          :title="links[currentIndex - 1].title"
          v-if="links[currentIndex - 1]"
        ></router-link>
        <div
          :class="['k-onboarding__step-line', {'step-active': currentIndex < $route.meta.tabIndex}]"
          v-if="currentIndex < maxTabs"
        ></div>
      </div>
    </div>
    <router-view :editProfile="routeProfile" @setNewProfile="setNewProfile">
      <div
        class="k-onboarding__quest-next k-onboarding__quest-next--orange active"
        v-if="$route.meta.tabIndex !== 1 && $route.meta.tabIndex !== this.routeIndexConditions.length - 1"
        @click="$router.push({name: links[$route.meta.tabIndex - 2].name})"
      >
        Назад
      </div>
       <span class="k-onboarding-skip mt-2 cursor-pointer" @click="createEmptyProfile">Пропустить</span>
      <div class="loading-indication" v-if="busyState">
        <k-spinner />
      </div>
    </router-view>
  </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import KSpinner from '../components/TheSpinner';
import GoBack from '../components/TheGoBack';

export default {
  name: "TheOnboarding",
  components: {
    KSpinner,
    GoBack,
  },
  props: {
    maxTabs: {
      required: true,
      type: Number
    },
    tabIndex: {
      required: true,
      type: Number
    },
  },
  computed: {
    ...mapGetters({
      currentProfile: "getCurrentProfile",
      userFamily: "getUserFamily"
    }),
    getGoBackText() {
      if (this.from === 'Index') return 'Назад в меню';
      else if (this.from === 'Profile') return 'Назад в профиль';
      return 'Назад'
    },
    getCurrentProfile() {
      return this.routeProfile
        ? this.userFamily.find(el => el.id === this.routeProfile.id)
        : this.currentProfile;
    },
    isCurrentProfile() {
      return this.getCurrentProfile || {}
    },
    routeProfile() {
      return this.newCreatedProfile;
    },
    routeIndexConditions() {
      return this.getCurrentProfile ?
      [
        !!this.getCurrentProfile.gender,
        !!this.getCurrentProfile.birth_date,
        !!this.getCurrentProfile.height,
        !!this.getCurrentProfile.weight,
        !!this.getCurrentProfile.activity,
        !!this.getCurrentProfile.goal,
        !!this.getCurrentProfile.calories,
      ] : []
    }
  },
  created() {
    this.from = this.$route.params.from || 'Index';
    if (
      !this.getCurrentProfile?.id &&
      this.$router.name !== "OnboardingGender" &&
      this.$router.name !== "OnboardingResult"
    ) {
      this.$router.push({ name: "OnboardingGender" });
    }
    if (this.$route.query.action === "edit" && this.$route.params.data) {
      this.newCreatedProfile = { ...this.$route.params.data };
      this.$router.replace({ name: "OnboardingGender", query: {} });
    }
  },
  methods: {
    ...mapActions([
      'createProfile'
    ]),
    handleBack() {
      this.$router.push({ name: this.from, params: {
        id: this.from === 'Profile' && this.routeProfile.id
      }})
    },
    setNewProfile(profile) {
      this.newCreatedProfile = { ...profile };
    },
    async createEmptyProfile() {
      /*
      if (this.busyState) return;

      this.busyState = true;
      await this.createProfile(true);

      this.busyState = false;
      */
      this.$router.push("/");
    }
  },
  data() {
    return {
      links: [
        { name: "OnboardingGender", title: "Шаг 1: Укажите пол" },
        { name: "OnboardingBirthday", title: "Шаг 2: Укажите дату рождения" },
        { name: "OnboardingHeight", title: "Шаг 3: Укажите рост" },
        { name: "OnboardingWeight", title: "Шаг 4: Укажите вес" },
        { name: "OnboardingActivity", title: "Шаг 5: Активность" },
        { name: "OnboardingGoals", title: "Шаг 6: Цели" },
        { name: "OnboardingResult", title: "Шаг 7: рассчет БЖУ" }
      ],
      newCreatedProfile: null,
      busyState: false,
      from: 'Index',
    };
  }
};
</script>

<style scoped>
.k-onboarding-skip {
  color: #808080;
}
</style>
